"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AnimatedSnack = _interopRequireDefault(require("./AnimatedSnack"));
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _snacks = require("../../selectors/snacks");
var _notifications = require("../../selectors/notifications");
var _notifications2 = require("../../constants/notifications");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Snackbar = (0, _react.memo)(({
  isHeader = true,
  delay = 3000,
  handleNotification
}) => {
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const notifications = (0, _Context.useSelector)(_snacks.getSnacks);
  const visible = (0, _Context.useSelector)(_notifications.isWidgetExpanded);
  const dispatch = (0, _Context.useDispatch)();
  const hideNotification = ({
    notification,
    conflictMsg,
    callback
  }) => {
    if (conflictMsg && notification.target === _notifications2.TARGETS.EXTERNAL) {
      dispatch(actions.updateNotificationPending(notification, conflictMsg, callback));
    } else if (callback) {
      callback();
    }
    dispatch(actions.clearSnack(notification));
  };
  return _react.default.createElement(_styles.SnackbarContainer, {
    reduced: visible,
    topBased: !isHeader
  }, _react.default.createElement(_styles.SnackbarContent, null, notifications.map(notification => _react.default.createElement(_AnimatedSnack.default, {
    key: notification.ID,
    notification: notification,
    localeData: locale,
    delay: notification.delay || delay,
    onHide: hideNotification,
    handleNotification: handleNotification
  }))));
});
var _default = exports.default = Snackbar;